export default "__VITE_ASSET__8d5e2006__"